import { call, put, takeLatest, select } from 'redux-saga/effects';
import { callWithAuth } from '../sagaApiHelper';
import { sendMediaMessageApi, validateMediaFile } from '../../api/apiLists/sendMediaMessageApi';

import { showAlert } from '../alertSlice';
import { uploadFileToS3 } from './fileUploadHelper';
import { fetchConversationRequest } from '../conversationSlice';
import {
  sendMediaMessageRequest,
  sendMediaMessageSuccess,
  sendMediaMessageFailure,
} from '../mediaMessageSlice';

function* handleSendMediaMessage(action) {
  try {
    const { file, conversationId, mediaType, caption, filename } = action.payload;
    const companyId = yield select(state => state.auth?.user?.companyId || state.auth?.companyId);

    if (!file || !conversationId || !mediaType) {
      const errorMsg = 'Missing required parameters for media message';
      yield put(sendMediaMessageFailure(errorMsg));
      yield put(showAlert({
        message: errorMsg,
        type: 'error'
      }));
      return;
    }

    const validation = validateMediaFile(file, mediaType);
    if (!validation.valid) {
      yield put(sendMediaMessageFailure(validation.error));
      yield put(showAlert({
        message: validation.error,
        type: 'error'
      }));
      return;
    }

    let s3Key = null;
    try {
      s3Key = yield call(uploadFileToS3, file, companyId, 'chat', { conversationId });
    } catch (uploadError) {
      const errorMsg = uploadError?.message || 'Failed to upload media file. Please try again.';
      yield put(sendMediaMessageFailure(errorMsg));
      yield put(showAlert({
        message: errorMsg,
        type: 'error'
      }));
      return;
    }

    if (!s3Key) {
      const errorMsg = 'Failed to upload media file. Please try again.';
      yield put(sendMediaMessageFailure(errorMsg));
      yield put(showAlert({
        message: errorMsg,
        type: 'error'
      }));
      return;
    }

    const messageParams = {
      conversationId,
      mediaType,
      mediaLink: s3Key,
      caption: caption || undefined,
      filename: filename || undefined,
    };

    const res = yield call(callWithAuth, sendMediaMessageApi, messageParams);

    if (res?.status === true) {
      yield put(sendMediaMessageSuccess());
      yield put(fetchConversationRequest({ conversationId, background: true }));
    } else {
      const errorMsg = res?.errMsg || 'Failed to send media message. Please try again.';
      yield put(sendMediaMessageFailure(errorMsg));
      yield put(showAlert({
        message: errorMsg,
        type: 'error'
      }));
    }
  } catch (error) {
    const errorMsg = error?.message || 'An error occurred while sending media message.';
    yield put(sendMediaMessageFailure(errorMsg));
    yield put(showAlert({
      message: errorMsg,
      type: 'error'
    }));
  }
}

function* mediaUploadSaga() {
  yield takeLatest(sendMediaMessageRequest.type, handleSendMediaMessage);
}

export default mediaUploadSaga;
